var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElButton',{attrs:{"type":"primary","icon":"el-icon-plus","loading":_vm.isLoading},nativeOn:{"click":function($event){return _vm.createNewApp.apply(null, arguments)}}},[_vm._v("\n  "+_vm._s(_vm.$t('APPS.NEW_APP'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }